import * as React from 'react';
import { FormControlLabel, FormGroup, Radio } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import _ from 'lodash';

interface FilterState {
  area: 'closed' | 'open' | null;
}

export const ClosedAreaFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);
  const [filterStates, setFilterStates] = React.useState<FilterState>({
    area: null,
  });
  const controlLabelClasses = {
    label: 'font-medium text-sm',
    root: 'm-0 py-1 hover:bg-blue-200 rounded-sm',
  };

  React.useEffect(() => {
    let area: FilterState['area'] = null;

    const { closedArea } = searchParams;
    if (closedArea === true) {
      area = 'closed';
    } else if (closedArea === false) {
      area = 'open';
    }

    setFilterStates({
      area,
    });
  }, [searchParams]);

  const handleChange = (key: FilterState['area']) => {
    const defaultSearchParams = {
      importStatus: key
        ? _.uniq(_.concat(searchParams.importStatus, ['yard', 'rail', 'unknown']))
        : null,
    };

    if (!key) {
      setSearchParams({
        ...defaultSearchParams,
        closedArea: null,
      });
    } else {
      setSearchParams({
        ...defaultSearchParams,
        closedArea: key === 'closed',
      });
    }
  };

  return (
    <FormGroup className="px-2">
      <FormControlLabel
        classes={controlLabelClasses}
        control={
          <Radio
            size="small"
            checked={filterStates.area === 'closed'}
            onChange={() => handleChange('closed')}
          />
        }
        label="Closed area"
      />
      <FormControlLabel
        classes={controlLabelClasses}
        control={
          <Radio
            size="small"
            checked={filterStates.area === 'open'}
            onChange={() => handleChange('open')}
          />
        }
        label="Not in closed area"
      />
      <FormControlLabel
        classes={controlLabelClasses}
        control={
          <Radio
            size="small"
            checked={filterStates.area === null}
            onChange={() => handleChange(null)}
          />
        }
        label="Any"
      />
    </FormGroup>
  );
};
ClosedAreaFilter.displayName = 'TrackAndTrace.Controls.filters.ClosedAreaFilter';
